import { createAction, props } from '@ngrx/store';
import { ITransactionResponse } from '../models/transactions.model';
import { ITransactionsRequest } from '../models/transactions.model';

export const loadTransactions = createAction(
  '[Transactions] Load Transactions',
  props<{ customerId: string; model: ITransactionsRequest }>()
);

export const loadTransactionsSuccess = createAction(
  '[Transactions] Load Transactions Success',
  props<{ response: ITransactionResponse[] }>()
);

export const loadTransactionsFailure = createAction('[Transactions] Load Transactions Failure', props<{ error: Error | any }>());
